import { render, staticRenderFns } from "./hqStuHealthKnowledgeTypeShow.vue?vue&type=template&id=cb0138e8&scoped=true"
import script from "./hqStuHealthKnowledgeTypeShow.vue?vue&type=script&lang=js"
export * from "./hqStuHealthKnowledgeTypeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0138e8",
  null
  
)

export default component.exports